/* Step per nuove traduzioni:
    1. Creare la chiave
    2. Aggiungere la chiave con la sua traduzione
    3. Andare nel componente dove c'è la stringa che si vuole tradurre e richiamare la chiave dell'enum
*/

export enum LocalizationIds {
    UserNotFound = "UserNotFound",
    UserAdded = "UserAdded",
    UserUpdated = "UserUpdated",
    UserRemoved = "UserRemoved",
    Add = "Add",
    ReceiveNotifications = "ReceiveNotifications",
    PleaseSetMessage = "PleaseSetMessage",
    ChooseDestinationTicket = "ChooseDestinationTicket",
    MoveMessage = "MoveMessage",
    Scheduling = "Scheduling",
    Absence = "Absence",
    SystemMessage = "SystemMessage",
    Dashboard = "Dashboard",
    Total = "Total",
    OpenNewTickets = "OpenNewTickets",
    ViewTickets = "ViewTickets",
    FileLoaded = "FileLoaded",
    LoadedFrom = "LoadedFrom",
    SaveAndShare = "SaveAndShare",
    Date = "Date",
    Sender = "Sender",
    Object = "Object",
    EmailFounded = "EmailFounded",
    CreatedBasedOnTicket = "CreatedBasedOnTicket",
    LinkedToTicket = "LinkedToTicket",
    MessageFromCustomer = "MessageFromCustomer",
    ShowTicketDetails = "ShowTicketDetails",
    Remove = "Remove",
    NoMessagePresent = "NoMessagePresent",
    ShareTicketWithTheCustomer = "ShareTicketWithTheCustomer",
    CustomerInvited = "CustomerInvited",
    UserDeleted = "UserDeleted",
    WelcomeTo = "WelcomeTo",
    ChooseMenuAction = "ChooseMenuAction",
    LoginButton = "LoginButton",
    PageOf = "PageOf",
    TotalData = "TotalData",
    FilterResults = "FilterResults",
    ShowAll = "ShowAll",
    Login = "Login",
    Confirm = "Confirm",
    Title = "Title",
    Any = "Any",
    NoDataFound = "NoDataFound",
    Cancel = "Cancel",
    Locale = "Locale",
    ExpectedDays = "ExpectedDays",
    TotalWorkedDays = "TotalWorkedDays",
    TotalDays = "TotalDays",
    RefineSearch = "RefineSearch",
    Italian = "Italian",
    English = "English",
    Tickets = "Tickets",
    TotalTickets = "TotalTickets",
    Users = "Users",
    User = "User",
    Filter = "Filter",
    Search = "Search",
    SearchUsers = "SearchUsers",
    ShowOnly = "ShowOnly",
    ActiveUsers = "ActiveUsers",
    DeletedUsers = "DeletedUsers",
    AddNew = "AddNew",
    Name = "Name",
    Email = "Email",
    Language = "Language",
    CreatedOn = "CreatedOn",
    NoUsersFound = "NoUsersFound",
    TotalUsers = "TotalUsers",
    NewUser = "NewUser",
    EditUser = "EditUser",
    FirstName = "FirstName",
    LastName = "LastName",
    IsAdmin = "IsAdmin",
    CustomersCanManageCustomerUsers = "CustomersCanManageCustomerUsers",
    Save = "Save",
    OnlyClosedTickets = "OnlyClosedTickets",
    OnlyMyTickets = "OnlyMyTickets",
    Ticket = "Ticket",
    Priority = "Priority",
    Status = "Status",
    NewStatus = "NewStatus",
    AssignedTo = "AssignedTo",
    NotAssigned = "NotAssigned",
    NewTicket = "NewTicket",
    Category = "Category",
    Number = "Number",
    Delete = "Delete",
    View = "View",
    NoSelectedOrders = "NoSelectedOrders",
    CreateTicket = "CreateTicket",
    CreateTicketStartFrom = "CreateTicketStartFrom",
    Edit = "Edit",
    Reporter = "Reporter",
    Messages = "Messages",
    UploadedFile = "UploadedFile",
    UploadingFile = "UploadingFile",
    File = "File",
    UploadedBy = "UploadedBy",
    EditTicketDetails = "EditTicketDetails",
    EditTicketTitle = "EditTicketTitle",
    MessageSaved = "MessageSaved",
    TicketSaved = "TicketSaved",
    UserSaved = "UserSaved",
    SavedReporter = "SavedReporter",
    CreateReporter = "CreateReporter",
    CreateReporterTitle = "CreateReporterTitle",
    Details = "Details",
    ResendEmailInvitation = "ResendEmailInvitation",
    ResendEmailInvitationConfirm = "ResendEmailInvitationConfirm",
    MailInviteWarning = "MailInviteWarning",
    All = "All",
    Open = "Open",
    Closed = "Closed",
    Mine = "Mine",
    Unassigned = "Unassigned",
    WaitingForSimec = "WaitingForSimec",
    WaitingForCustomer = "WaitingForCustomer",
    AdvancedSearch = "AdvancedSearch",
    DeleteUserConfirm = "DeleteUserConfirm",
    SelectedSubcategories = "SelectedSubcategories",
    AllSubcategoriesSelected = "AllSubcategoriesSelected",
    Week = "Week",
    Month = "Month",
    NoOptionsFound = "NoOptionsFound",
    Order = "Orders",
    Orders = "Order",
    WorkOrder = "WorkOrder",
    WorkOrders = "WorkOrders",
    SearchMachine = "SearchMachine",
    SearchMachineExtended = "SearchMachineExtended",
    NoOne = "NoOne",
    Customer = "Customer",
    AllTickets = "AllTickets",
    OpenTickets = "OpenTickets",
    ClosedTickets = "ClosedTickets",
    AssignedToMe = "AssignedToMe",
    Others = "Others",
    Documents = "Documents",
    LinkedOrders = "LinkedOrders",
    Activities = "Activities",
    People = "People",
    Team = "Team",
    TeamMember = "TeamMember",
    From = "From",
    To = "To",
    OtherTickets = "OtherTickets",
    DateFrom = "DateFrom",
    DateTo = "DateTo",
    SaveChanges = "SaveChanges",
    NoResults = "NoResults",
    ChooseTeamMember = "ChooseTeamMember",
    Assignee = "Assignee",
    AddUser = "AddUser",
    FileUploaded = "FileUploaded",
    Rev = "Rev",
    LastUpdate = "LastUpdate",
    FileName = "FileName",
    Download = "Download",
    Restore = "Restore",
    CreateRevision = "CreateRevision",
    ShowDeleted = "ShowDeleted",
    NoContainerFound = "NoContainerFound",
    Description = "Description",
    AddOrder = "AddOrder",
    OrdersFound = "OrdersFound",
    WorkOrdersFound = "WorkOrdersFound",
    Close = "Close",
    SearchOrders = "SearchOrders",
    SearchWorkOrders = "SearchWorkOrders",
    OrderNumber = "OrderNumber",
    Typology = "Typology",
    CommercialCode = "CommercialCode",
    ArticleModel = "ArticleModel",
    Quote = "Quote",
    Layout = "Layout",
    NoOrdersFound = "NoOrdersFound",
    Article = "Article",
    Quantity = "Quantity",
    NoWorkOrdersFound = "NoWorkOrdersFound",
    CreatedBy = "CreatedBy",
    Origin = "Origin",
    Activity = "Activity",
    Yes = "Yes",
    No = "No",
    SharedWithCustomer = "SharedWithCustomer",
    NotSharedWithCustomer = "NotSharedWithCustomer",
    CannotUploadFiles = "CannotUploadFiles",
    Click = "Click",
    DragFilesHere = "DragFilesHere",
    Or = "Or",
    ToSearchOne = "ToSearchOne",
    NoMessagesFound = "NoMessagesFound",
    On = "On",
    CanGoToCustomer = "CanGoToCustomer",
    EditCanGoToCustomer = "EditCanGoToCustomer",
    LoginAs = "LoginAs",
    Country = "Country",
    JobSiteFrom = "JobSiteFrom",
    JobSiteTo = "JobSiteTo",
    JobSite = "JobSite",
    ShowFilter = "ShowFilter",
    SubCategories = "SubCategories",
    SomethingWrong = "SomethingWrong",
    TryLoginLogout = "TryLoginLogout",
    ShowEmptyRows = "ShowEmptyRows",
    Technician = "Technician",
    RestoreUser = "RestoreUser",
    Groups = "Groups",
    CustomersSummary = "CustomersSummary",
    SummaryActualityPast = "SummaryActualityPast",
    SummaryActualityPresent = "SummaryActualityPresent",
    SummaryActualityFuture = "SummaryActualityFuture",
    SortBy = "SortBy",
    SelectCustomerOrMachineToSetReporter = "SelectCustomerOrMachineToSetReporter",
    CustomerCanView = "CustomerCanView",
    SimecPrivateTicket = "SimecPrivateTicket",
    ClearFilters = "ClearFilters",
    OtherLinkedOrdersInTab = "OtherLinkedOrdersInTab",
    RequiredField = "RequiredField",
    Queue = "Queue",
    DashboardByAssignee = "DashboardByAssignee",
    DashboardByCategoryAndStatus = "DashboardByCategoryAndStatus",

    INFO_RestoreUserConfirm = "RestoreUserConfirm",
    INFO_MoveMessageToTicket = "INFO_MoveMessageToTicket",
    INFO_ChangeCustomersOrders = "INFO_ChangeCustomersOrders",
    INFO_RemoveTicket = "INFO_RemoveTicket",
    INFO_TicketRemoved = "INFO_TicketRemoved",
    INFO_TicketSaved = "INFO_TicketSaved",
    INFO_RemoveUserFromTicketNotifications = "INFO_RemoveUserFromTicketNotifications",
    INFO_DocumentRemove = "INFO_DocumentRemove",
    INFO_DocumentRestore = "INFO_DocumentRestore",
    INFO_FillFields = "INFO_FillFields",
    INFO_RemoveUserFromTeam = "INFO_RemoveUserFromTeam",
    INFO_TeamSaved = "INFO_TeamSaved",
    INFO_OrderAlreadySelected = "INFO_OrderAlreadySelected",
    INFO_DeleteOrder = "INFO_DeleteOrder",
    INFO_MessageSaved = "INFO_MessageSaved",
    INFO_ErrorFileUploaded = "INFO_ErrorFileUploaded",
    INFO_AttachmentDuplicated = "INFO_AttachmentDuplicated",

    ERR_CANT_MOVE_MESSAGE = "ERR_CANT_MOVE_MESSAGE",
    ERR_FILE_DOWNLOAD = "ERR_FILE_DOWNLOAD",
    ERR_FILE_IMPORT = "ERR_FILE_IMPORT",
    ERR_USER_NOT_FOUND = "ERR_USER_NOT_FOUND",
    ERR_CANNOT_SET_EMAIL = "ERR_CANNOT_SET_EMAIL",
    ERR_TICKET_NOT_FOUND = "ERR_TICKET_NOT_FOUND",
    ERR_TICKET_NOT_FOUND_CANNOT_SAVE = "ERR_TICKET_NOT_FOUND_CANNOT_SAVE",
    ERR_TICKET_NOT_VISIBLE = "ERR_TICKET_NOT_VISIBLE",
    ERR_INVALID_REPORTER_EMAIL = "ERR_INVALID_REPORTER_EMAIL",
    ERR_INVALID_REPORTER_CUSTOMERID = "ERR_INVALID_REPORTER_CUSTOMERID",
    ERR_DUPLICATE_CODES = "ERR_DUPLICATE_CODES",
    ERR_CATEGORY_NOT_FOUND = "ERR_CATEGORY_NOT_FOUND",
    ERR_OPERATION_NOT_PERMITTED = "ERR_OPERATION_NOT_PERMITTED",
    ERR_MESSAGE_NOT_FOUND = "ERR_MESSAGE_NOT_FOUND",
    ERR_DUPLICATED_USER = "ERR_DUPLICATED_USER",
    ERR_DUPLICATED_CUSTOMER = "ERR_DUPLICATED_CUSTOMER",
    ERR_MAXDATE_MUST_GREATERTHANOREQUAL_MINDATE = "ERR_MAXDATE_MUST_GREATERTHANOREQUAL_MINDATE",
    ERR_NEW_PASSWORD_REQUIRED = "ERR_NEW_PASSWORD_REQUIRED",
    ERR_NEW_PASSWORD_MISMATCH = "ERR_NEW_PASSWORD_MISMATCH",
    ERR_RESET_PASSWORD = "ERR_RESET_PASSWORD",
    ERR_UPLOAD_ATTACHMENT = "ERR_UPLOAD_ATTACHMENT",
    ERR_SAVE_MESSAGE = "ERR_SAVE_MESSAGE",
    ERR_INVALID_CUSTOMER_EMAIL = "ERR_INVALID_CUSTOMER_EMAIL"
}

const itITMessages = {
    [LocalizationIds.UserNotFound]: "Utente non trovato",
    [LocalizationIds.UserAdded]: "Utente aggiunto",
    [LocalizationIds.UserUpdated]: "Utente aggiornato",
    [LocalizationIds.UserRemoved]: "Utente rimosso",
    [LocalizationIds.Add]: "Aggiungi",
    [LocalizationIds.ReceiveNotifications]: "Riceve le notifiche",
    [LocalizationIds.PleaseSetMessage]: "Si prega di inserire il messaggio",
    [LocalizationIds.ChooseDestinationTicket]: "Indica il numero del ticket di destinazione",
    [LocalizationIds.MoveMessage]: "Sposta messaggio in ticket",
    [LocalizationIds.Scheduling]: "Pianificazione",
    [LocalizationIds.Absence]: "Assenze",
    [LocalizationIds.SystemMessage]: "Messaggio di sistema",
    [LocalizationIds.AdvancedSearch]: "Ricerca avanzata",
    [LocalizationIds.WaitingForSimec]: "In attesa di Simec",
    [LocalizationIds.WaitingForCustomer]: "In attesa del cliente",
    [LocalizationIds.Dashboard]: "Dashboard",
    [LocalizationIds.Total]: "Totale",
    [LocalizationIds.Queue]: "Ricerche",
    [LocalizationIds.DashboardByAssignee]: "Tickets per assegnatario da evadere",
    [LocalizationIds.DashboardByCategoryAndStatus]: "Tickets per status",
    [LocalizationIds.CustomerInvited]: "Cliente invitato",
    [LocalizationIds.LoadedFrom]: "Loaded From",
    [LocalizationIds.FileLoaded]: "File Caricato",
    [LocalizationIds.EmailFounded]: "Email Trovate",
    [LocalizationIds.Sender]: "Mittente",
    [LocalizationIds.Object]: "Oggetto",
    [LocalizationIds.Date]: "Data",
    [LocalizationIds.SaveAndShare]: "Salva e condividi",
    [LocalizationIds.CreatedBasedOnTicket]: "Creato a partire dal ticket",
    [LocalizationIds.LinkedToTicket]: "Collegato al ticket",
    [LocalizationIds.ShowTicketDetails]: "Mostra dettagli Ticket",
    [LocalizationIds.Remove]: "Rimuovi",
    [LocalizationIds.NoMessagePresent]: "Nessun messaggio presente",
    [LocalizationIds.MessageFromCustomer]: "Messaggio da cliente",
    [LocalizationIds.ShareTicketWithTheCustomer]: "Condividi ticket con il cliente",
    [LocalizationIds.UserDeleted]: "Utente eliminato",
    [LocalizationIds.WelcomeTo]: "Benvenuti su",
    [LocalizationIds.ChooseMenuAction]: "Seleziona una voce del menu per cominciare!",
    [LocalizationIds.LoginButton]: "Accedi con le tue credenziali Athena",
    [LocalizationIds.PageOf]: "Pagina {pageNr} di {count}",
    [LocalizationIds.TotalData]: "{total} elementi trovati",
    [LocalizationIds.FilterResults]: "Filtra risultati",
    [LocalizationIds.ShowAll]: "Mostra Tutti",
    [LocalizationIds.Login]: "Esegui il login con le credenziali Athena",
    [LocalizationIds.Confirm]: "Conferma",
    [LocalizationIds.Any]: "Qualsiasi",
    [LocalizationIds.Title]: "Titolo",
    [LocalizationIds.NoDataFound]: "Nessun dato trovato",
    [LocalizationIds.Locale]: "Lingue",
    [LocalizationIds.Cancel]: "Annulla",
    [LocalizationIds.RefineSearch]: "Perfeziona la tua ricerca:",
    [LocalizationIds.Tickets]: "Elenco ticket",
    [LocalizationIds.TotalTickets]: "Ticket trovati",
    [LocalizationIds.Italian]: "Italiano",
    [LocalizationIds.English]: "Inglese",
    [LocalizationIds.Users]: "Utenti",
    [LocalizationIds.User]: "Utente",
    [LocalizationIds.Filter]: "Filtro",
    [LocalizationIds.Search]: "Cerca",
    [LocalizationIds.SearchUsers]: "Cerca utenti",
    [LocalizationIds.ShowOnly]: "Mostra solo",
    [LocalizationIds.ActiveUsers]: "Utenti attivi",
    [LocalizationIds.DeletedUsers]: "Utenti eliminati",
    [LocalizationIds.AddNew]: "Aggiungi",
    [LocalizationIds.Name]: "Nome",
    [LocalizationIds.Email]: "Email",
    [LocalizationIds.Language]: "Lingua",
    [LocalizationIds.CreatedOn]: "Creato Il",
    [LocalizationIds.NoUsersFound]: "Nessun utente trovato",
    [LocalizationIds.TotalUsers]: "Utenti totali",
    [LocalizationIds.NewUser]: "Nuovo utente",
    [LocalizationIds.EditUser]: "Modifica utente",
    [LocalizationIds.FirstName]: "Nome",
    [LocalizationIds.LastName]: "Cognome",
    [LocalizationIds.IsAdmin]: "È Amministratore",
    [LocalizationIds.Save]: "Salva",
    [LocalizationIds.OnlyClosedTickets]: "Solo ticket chiusi",
    [LocalizationIds.OnlyMyTickets]: "Solo i miei ticket",
    [LocalizationIds.Ticket]: "Ticket",
    [LocalizationIds.Priority]: "Priorità",
    [LocalizationIds.Status]: "Status",
    [LocalizationIds.NewStatus]: "Nuovo Status",
    [LocalizationIds.AssignedTo]: "Assegnato a",
    [LocalizationIds.NotAssigned]: "Non Assegnato",
    [LocalizationIds.NewTicket]: "Nuovo Ticket",
    [LocalizationIds.Category]: "Categoria",
    [LocalizationIds.Number]: "Numero",
    [LocalizationIds.Delete]: "Elimina",
    [LocalizationIds.View]: "Visualizza",
    [LocalizationIds.NoSelectedOrders]: "Nessun ordine selezionato",
    [LocalizationIds.CreateTicket]: "Crea Ticket",
    [LocalizationIds.Edit]: "Modifica",
    [LocalizationIds.Reporter]: "Reporter",
    [LocalizationIds.Messages]: "Messaggi",
    [LocalizationIds.UploadedFile]: "File caricato",
    [LocalizationIds.UploadingFile]: "File in caricamento",
    [LocalizationIds.File]: "File",
    [LocalizationIds.UploadedBy]: "Caricato da",
    [LocalizationIds.EditTicketDetails]: "Modifica dettagli Ticket",
    [LocalizationIds.EditTicketTitle]: "Modifica il titolo del ticket",
    [LocalizationIds.MessageSaved]: "Messaggio salvato",
    [LocalizationIds.TicketSaved]: "Ticket salvato",
    [LocalizationIds.UserSaved]: "Utente salvato",
    [LocalizationIds.CustomersCanManageCustomerUsers]: "Può gestire utenti",
    [LocalizationIds.SavedReporter]: "Reporter salvato",
    [LocalizationIds.CreateReporter]: "Aggiungi Reporter",
    [LocalizationIds.CreateReporterTitle]: "Crea un nuovo utente da impostare come Reporter",
    [LocalizationIds.Details]: "Dettagli",
    [LocalizationIds.ResendEmailInvitation]: "Invia una nuova Email di invito",
    [LocalizationIds.ResendEmailInvitationConfirm]: "Sicuro di voler inviare nuovamente l'email di invito?",
    [LocalizationIds.DeleteUserConfirm]: "Sicuro di voler eliminare questo utente?",
    [LocalizationIds.MailInviteWarning]: "L’utente riceverà una mail di invito per accedere a MySimec",
    [LocalizationIds.All]: "Tutti",
    [LocalizationIds.Open]: "Aperti",
    [LocalizationIds.Closed]: "Chiusi",
    [LocalizationIds.Mine]: "Miei",
    [LocalizationIds.Unassigned]: "Non assegnati",
    [LocalizationIds.SelectedSubcategories]: "{count} Sottocategorie selezionate",
    [LocalizationIds.AllSubcategoriesSelected]: "Visualizza sottocategorie specifiche",
    [LocalizationIds.Week]: "Settimana",
    [LocalizationIds.Month]: "Mese",
    [LocalizationIds.NoOptionsFound]: "Nessun risultato è stato trovato",
    [LocalizationIds.Order]: "Ordine Cliente",
    [LocalizationIds.WorkOrder]: "Ordine Produzione",
    [LocalizationIds.Orders]: "Ordini Cliente",
    [LocalizationIds.WorkOrders]: "Ordini Produzione",
    [LocalizationIds.SearchMachine]: "Cerca una macchina",
    [LocalizationIds.SearchMachineExtended]: "Cerca una macchina (numero di serie, modello, descrizione)",
    [LocalizationIds.NoOne]: "Nessuno",
    [LocalizationIds.Customer]: "Cliente",
    [LocalizationIds.AllTickets]: "Tutti i ticket",
    [LocalizationIds.ViewTickets]: "Visualizza tickets",
    [LocalizationIds.OpenNewTickets]: "Apri ticket",
    [LocalizationIds.OpenTickets]: "Aperti",
    [LocalizationIds.ClosedTickets]: "Chiusi",
    [LocalizationIds.AssignedToMe]: "Assegnati a me",
    [LocalizationIds.Others]: "Altri",
    [LocalizationIds.Documents]: "Documenti",
    [LocalizationIds.LinkedOrders]: "Ordini Collegati",
    [LocalizationIds.Activities]: "Attività",
    [LocalizationIds.People]: "Persone",
    [LocalizationIds.Team]: "Squadra",
    [LocalizationIds.TeamMember]: "In Squadra",
    [LocalizationIds.TotalDays]: "Giorni totali",
    [LocalizationIds.ExpectedDays]: "Giorni previsti",
    [LocalizationIds.TotalWorkedDays]: "Giorni lavorati",
    [LocalizationIds.From]: "Da",
    [LocalizationIds.To]: "A",
    [LocalizationIds.OtherTickets]: "Altri Tickets",
    [LocalizationIds.DateFrom]: "Da data",
    [LocalizationIds.DateTo]: "A data",
    [LocalizationIds.SaveChanges]: "Salva Modifiche",
    [LocalizationIds.NoResults]: "Nessun risultato trovato",
    [LocalizationIds.ChooseTeamMember]: "Seleziona utente in squadra",
    [LocalizationIds.Assignee]: "Assegnatario",
    [LocalizationIds.AddUser]: "Aggiungi persona",
    [LocalizationIds.FileUploaded]: "File caricato",
    [LocalizationIds.Rev]: "Rev.",
    [LocalizationIds.LastUpdate]: "Ultimo aggiornamento",
    [LocalizationIds.FileName]: "Nome file",
    [LocalizationIds.Download]: "Download",
    [LocalizationIds.Restore]: "Ripristina",
    [LocalizationIds.CreateRevision]: "Crea revisione",
    [LocalizationIds.ShowDeleted]: "Mostra eliminati",
    [LocalizationIds.NoContainerFound]: "Nessun contenitore trovato",
    [LocalizationIds.Description]: "Descrizione",
    [LocalizationIds.AddOrder]: "Aggiungi ordine",
    [LocalizationIds.OrdersFound]: "Ordini trovati",
    [LocalizationIds.WorkOrdersFound]: "Commesse trovate",
    [LocalizationIds.Close]: "Chiudi",
    [LocalizationIds.SearchOrders]: "Cerca ordini cliente",
    [LocalizationIds.SearchWorkOrders]: "Cerca ordini produzione",
    [LocalizationIds.OrderNumber]: "Numero ordine",
    [LocalizationIds.Typology]: "Tipologia",
    [LocalizationIds.CommercialCode]: "Codice Commerciale",
    [LocalizationIds.ArticleModel]: "Modello Articolo",
    [LocalizationIds.Quote]: "Offerta",
    [LocalizationIds.Layout]: "Layout",
    [LocalizationIds.NoOrdersFound]: "Nessun ordine trovato",
    [LocalizationIds.Article]: "Articolo",
    [LocalizationIds.Quantity]: "Quantità",
    [LocalizationIds.NoWorkOrdersFound]: "Nessuna commessa trovata",
    [LocalizationIds.CreatedBy]: "Creato Da",
    [LocalizationIds.Origin]: "Origine",
    [LocalizationIds.Activity]: "Attività",
    [LocalizationIds.Yes]: "Si",
    [LocalizationIds.No]: "No",
    [LocalizationIds.SharedWithCustomer]: "Condiviso con il cliente",
    [LocalizationIds.CannotUploadFiles]: "Non è possibile caricare questi files",
    [LocalizationIds.Click]: "Clicca",
    [LocalizationIds.DragFilesHere]: "Trascina qui i files",
    [LocalizationIds.Or]: "Oppure",
    [LocalizationIds.ToSearchOne]: "Per cercarne uno",
    [LocalizationIds.NoMessagesFound]: "Nessun messaggio presente",
    [LocalizationIds.On]: "Il",
    [LocalizationIds.CreateTicketStartFrom]: "Crea nuovo ticket",
    [LocalizationIds.NotSharedWithCustomer]: "Visibile solo a Simec",
    [LocalizationIds.EditCanGoToCustomer]: "Modifica 'Può andare da cliente'",
    [LocalizationIds.CanGoToCustomer]: "Può andare da cliente",
    [LocalizationIds.LoginAs]: "Accedi come",
    [LocalizationIds.Country]: "Nazione",
    [LocalizationIds.JobSiteFrom]: "Intervento da",
    [LocalizationIds.JobSiteTo]: "Intervento a",
    [LocalizationIds.JobSite]: "Intervento",
    [LocalizationIds.ShowFilter]: "Mostra filtro",
    [LocalizationIds.SubCategories]: "Sottocategorie",
    [LocalizationIds.SelectCustomerOrMachineToSetReporter]: "Seleziona il cliente o una macchina per impostare il referente",
    [LocalizationIds.CustomerCanView]: "Condiviso con il cliente",
    [LocalizationIds.SimecPrivateTicket]: "Ticket privato Simec",
    [LocalizationIds.SomethingWrong]: "Qualcosa non va con il tuo utente.",
    [LocalizationIds.TryLoginLogout]: "Prova a rieseguire il login: se non cambia nulla chiedi al supporto tecnico.",
    [LocalizationIds.ShowEmptyRows]: "Mostra tecnici non pianificati",
    [LocalizationIds.Technician]: "Tecnico",
    [LocalizationIds.ClearFilters]: "Pulisci filtri",
    [LocalizationIds.OtherLinkedOrdersInTab]: "Ci sono altri ordini collegati visibili da tab 'Ordini collegati'",
    [LocalizationIds.RequiredField]: "{field} è un campo obbligatorio",
    [LocalizationIds.RestoreUser]: "Ripristina utente",
    [LocalizationIds.Groups]: "Gruppi",
    [LocalizationIds.CustomersSummary]: "Report",
    [LocalizationIds.SummaryActualityPast]: "Effettuato",
    [LocalizationIds.SummaryActualityPresent]: "In corso",
    [LocalizationIds.SummaryActualityFuture]: "Pianificato",
    [LocalizationIds.SortBy]: "Ordina per",

    [LocalizationIds.INFO_MoveMessageToTicket]: "Sicuro di voler spostare il messaggio nel ticket indicato?",
    [LocalizationIds.INFO_RestoreUserConfirm]: "Sicuro di voler ripristinare questo utente?",
    [LocalizationIds.INFO_RemoveTicket]: "Sicuro di voler eliminare questo ticket?",
    [LocalizationIds.INFO_ChangeCustomersOrders]: "Modificando il cliente gli eventuali ordini associati al ticket saranno rimossi",
    [LocalizationIds.INFO_RemoveUserFromTicketNotifications]: "Sei sicuro di voler rimuovere l'utente dalle notifiche?",
    [LocalizationIds.INFO_TicketSaved]: "Ticket salvato",
    [LocalizationIds.INFO_TicketRemoved]: "Ticket eliminato",
    [LocalizationIds.INFO_DocumentRemove]: "Sei sicuro di voler eliminare il documento?",
    [LocalizationIds.INFO_DocumentRestore]: "Sei sicuro di voler ripristinare il documento?",
    [LocalizationIds.INFO_RemoveUserFromTeam]: "Sei sicuro di voler rimuovere l'utente dal team?",
    [LocalizationIds.INFO_FillFields]: "Compilare i campi",
    [LocalizationIds.INFO_TeamSaved]: "Squadra salvata",
    [LocalizationIds.INFO_OrderAlreadySelected]: "Ordine già selezionato",
    [LocalizationIds.INFO_DeleteOrder]: "Sicuro di voler rimuovere l'ordine?",
    [LocalizationIds.INFO_MessageSaved]: "Messaggio salvato",
    [LocalizationIds.INFO_ErrorFileUploaded]: "Errore durante il caricamento del file",
    [LocalizationIds.INFO_AttachmentDuplicated]: "Allegato già presente",

    [LocalizationIds.ERR_CANT_MOVE_MESSAGE]: "Questo messaggio non può essere spostato",
    [LocalizationIds.ERR_FILE_DOWNLOAD]: "Errore durante il download del file",
    [LocalizationIds.ERR_FILE_IMPORT]: "Errore durante l'importazione del file",
    [LocalizationIds.ERR_USER_NOT_FOUND]: "Utente non trovato",
    [LocalizationIds.ERR_CANNOT_SET_EMAIL]: "Impossibile impostare la mail per l'utente",
    [LocalizationIds.ERR_TICKET_NOT_FOUND]: "Ticket non trovato",
    [LocalizationIds.ERR_TICKET_NOT_FOUND_CANNOT_SAVE]: "Ticket non trovato, impossibile salvare",
    [LocalizationIds.ERR_TICKET_NOT_VISIBLE]: "Utente non autorizzato alla visione di questo ticket",
    [LocalizationIds.ERR_INVALID_REPORTER_EMAIL]: "Impossibile salvare: email non valida",
    [LocalizationIds.ERR_INVALID_REPORTER_CUSTOMERID]: "Impossibile salvare: cliente non valido",
    [LocalizationIds.ERR_DUPLICATE_CODES]: "Impossibile salvare: codici duplicati",
    [LocalizationIds.ERR_CATEGORY_NOT_FOUND]: "Impossibile salvare: categoria non trovata",
    [LocalizationIds.ERR_OPERATION_NOT_PERMITTED]: "Operazione non permessa",
    [LocalizationIds.ERR_MESSAGE_NOT_FOUND]: "Messaggio non trovato",
    [LocalizationIds.ERR_DUPLICATED_USER]: "Esiste già un account con questa mail negli utenti",
    [LocalizationIds.ERR_DUPLICATED_CUSTOMER]: "Esiste già un account con questa mail nei clienti",
    [LocalizationIds.ERR_MAXDATE_MUST_GREATERTHANOREQUAL_MINDATE]: "La data di inizio non può essere maggiore di quella di fine",
    [LocalizationIds.ERR_NEW_PASSWORD_REQUIRED]: "E' necessario specificare la nuova password",
    [LocalizationIds.ERR_NEW_PASSWORD_MISMATCH]: "Le due password non corrispondono",
    [LocalizationIds.ERR_RESET_PASSWORD]: "Errore in fase di reset password, si prega di riprovare",
    [LocalizationIds.ERR_UPLOAD_ATTACHMENT]: "Errore in fase di upload allegato",
    [LocalizationIds.ERR_SAVE_MESSAGE]: "Impossibile salvare un messaggio vuoto",
    [LocalizationIds.ERR_INVALID_CUSTOMER_EMAIL]: "Impossibile salvare: email non valida",
};

const enUSMessages = {
    [LocalizationIds.UserNotFound]: "User not found",
    [LocalizationIds.UserAdded]: "User added",
    [LocalizationIds.UserUpdated]: "User updated",
    [LocalizationIds.UserRemoved]: "User removed",
    [LocalizationIds.Add]: "Add",
    [LocalizationIds.ReceiveNotifications]: "Receive notifications",
    [LocalizationIds.PleaseSetMessage]: "Si prega di inserire il messaggio",
    [LocalizationIds.ChooseDestinationTicket]: "Choose the destination ticket",
    [LocalizationIds.MoveMessage]: "Move message to ticket",
    [LocalizationIds.Scheduling]: "Pianificazione",
    [LocalizationIds.Absence]: "Absences",
    [LocalizationIds.SystemMessage]: "System message",
    [LocalizationIds.AdvancedSearch]: "Advanced search",
    [LocalizationIds.WaitingForSimec]: "Waiting for Simec",
    [LocalizationIds.WaitingForCustomer]: "Waiting for customer",
    [LocalizationIds.Dashboard]: "Dashboard",
    [LocalizationIds.Total]: "Total",
    [LocalizationIds.Queue]: "Queues",
    [LocalizationIds.DashboardByAssignee]: "Tickets by assignee to be processed",
    [LocalizationIds.DashboardByCategoryAndStatus]: "Tickets by status",
    [LocalizationIds.ViewTickets]: "View tickets",
    [LocalizationIds.OpenNewTickets]: "Open Ticket",
    [LocalizationIds.EmailFounded]: "Email founded",
    [LocalizationIds.LoadedFrom]: "Caricato da",
    [LocalizationIds.FileLoaded]: "File Loaded",
    [LocalizationIds.Sender]: "Sender",
    [LocalizationIds.Object]: "Object",
    [LocalizationIds.Date]: "Date",
    [LocalizationIds.CustomerInvited]: "Customer invited",
    [LocalizationIds.SaveAndShare]: "Save and Share",
    [LocalizationIds.ShowTicketDetails]: "Show Ticket details",
    [LocalizationIds.Remove]: "Remove",
    [LocalizationIds.NoMessagePresent]: "No message present",
    [LocalizationIds.MessageFromCustomer]: "Message from customer",
    [LocalizationIds.UserDeleted]: "User deleted",
    [LocalizationIds.ShareTicketWithTheCustomer]: "Share ticket whith the customer",
    [LocalizationIds.WelcomeTo]: "Welcome to",
    [LocalizationIds.ChooseMenuAction]: "Choose a menu action to start!",
    [LocalizationIds.LoginButton]: "Login with Athena Credentials",
    [LocalizationIds.PageOf]: "Page {pageNr} of {count}",
    [LocalizationIds.TotalData]: "{total} elements found",
    [LocalizationIds.FilterResults]: "Filter results",
    [LocalizationIds.ShowAll]: "Show All",
    [LocalizationIds.Confirm]: "Confirm",
    [LocalizationIds.Any]: "Any",
    [LocalizationIds.Title]: "Title",
    [LocalizationIds.NoDataFound]: "No data were found",
    [LocalizationIds.Locale]: "Locale",
    [LocalizationIds.Cancel]: "Cancel",
    [LocalizationIds.RefineSearch]: "Refine your search:",
    [LocalizationIds.Tickets]: "Ticket list",
    [LocalizationIds.TotalTickets]: "Found tickets",
    [LocalizationIds.Italian]: "Italian",
    [LocalizationIds.English]: "English",
    [LocalizationIds.Users]: "Users",
    [LocalizationIds.User]: "User",
    [LocalizationIds.Filter]: "Filter",
    [LocalizationIds.Search]: "Search",
    [LocalizationIds.SearchUsers]: "Search users",
    [LocalizationIds.ShowOnly]: "Show only",
    [LocalizationIds.ActiveUsers]: "Active users",
    [LocalizationIds.DeletedUsers]: "Deleted users",
    [LocalizationIds.AddNew]: "Add New",
    [LocalizationIds.Name]: "Name",
    [LocalizationIds.Email]: "Email",
    [LocalizationIds.Language]: "Language",
    [LocalizationIds.CreatedOn]: "Created on",
    [LocalizationIds.NoUsersFound]: "No users were found",
    [LocalizationIds.TotalUsers]: "Total users",
    [LocalizationIds.NewUser]: "New user",
    [LocalizationIds.EditUser]: "Edit user",
    [LocalizationIds.FirstName]: "First Name",
    [LocalizationIds.LastName]: "Last Name",
    [LocalizationIds.IsAdmin]: "Is Admin",
    [LocalizationIds.Save]: "Save",
    [LocalizationIds.OnlyClosedTickets]: "Only Closed Tickets",
    [LocalizationIds.OnlyMyTickets]: "Only My Tickets",
    [LocalizationIds.Ticket]: "Ticket",
    [LocalizationIds.Priority]: "Priority",
    [LocalizationIds.Status]: "Status",
    [LocalizationIds.NewStatus]: "New Status",
    [LocalizationIds.AssignedTo]: "Assigned to",
    [LocalizationIds.NotAssigned]: "Not Assigned",
    [LocalizationIds.NewTicket]: "New Ticket",
    [LocalizationIds.Category]: "Category",
    [LocalizationIds.Number]: "Number",
    [LocalizationIds.Delete]: "Delete",
    [LocalizationIds.View]: "Visualizza",
    [LocalizationIds.NoSelectedOrders]: "No selected orders",
    [LocalizationIds.CreateTicket]: "Create Ticket",
    [LocalizationIds.Edit]: "Edit",
    [LocalizationIds.Reporter]: "Reporter",
    [LocalizationIds.Messages]: "Messages",
    [LocalizationIds.UploadedFile]: "Uploaded file",
    [LocalizationIds.UploadingFile]: "Uploading file",
    [LocalizationIds.File]: "File",
    [LocalizationIds.UploadedBy]: "Uploaded By",
    [LocalizationIds.EditTicketDetails]: "Edit ticket details",
    [LocalizationIds.EditTicketTitle]: "Edit ticket title",
    [LocalizationIds.MessageSaved]: "Message saved",
    [LocalizationIds.TicketSaved]: "Ticket saved",
    [LocalizationIds.UserSaved]: "User saved",
    [LocalizationIds.CustomersCanManageCustomerUsers]: "Can manage users",
    [LocalizationIds.SavedReporter]: "Reporter saved",
    [LocalizationIds.CreateReporter]: "Create Reporter",
    [LocalizationIds.CreateReporterTitle]: "Create a new user that will be set as Reporter",
    [LocalizationIds.Details]: "Details",
    [LocalizationIds.ResendEmailInvitation]: "Resend invitation Email",
    [LocalizationIds.ResendEmailInvitationConfirm]: "Are you sure that you want to re-send invitation email?",
    [LocalizationIds.DeleteUserConfirm]: "Are you sure that you want to delete this user?",
    [LocalizationIds.MailInviteWarning]: "User will receive an invitation email to access MySimec",
    [LocalizationIds.All]: "All",
    [LocalizationIds.Open]: "Open",
    [LocalizationIds.Closed]: "Closed",
    [LocalizationIds.Mine]: "Mine",
    [LocalizationIds.Unassigned]: "Unassigned",
    [LocalizationIds.SelectedSubcategories]: "{count} Selected subcategories",
    [LocalizationIds.AllSubcategoriesSelected]: "Show only specific subcategories",
    [LocalizationIds.Week]: "Week",
    [LocalizationIds.Month]: "Month",
    [LocalizationIds.NoOptionsFound]: "No options has been found",
    [LocalizationIds.Order]: "Customer Order",
    [LocalizationIds.WorkOrder]: "Production Order",
    [LocalizationIds.Orders]: "Customer Orders",
    [LocalizationIds.WorkOrders]: "Production Orders",
    [LocalizationIds.SearchMachine]: "Search for a machine",
    [LocalizationIds.SearchMachineExtended]: "Search for a machine (serial number, model, description)",
    [LocalizationIds.NoOne]: "No one",
    [LocalizationIds.Customer]: "Customer",
    [LocalizationIds.AllTickets]: "All Tickets",
    [LocalizationIds.OpenTickets]: "Open",
    [LocalizationIds.ClosedTickets]: "Closed",
    [LocalizationIds.AssignedToMe]: "Assigned to me",
    [LocalizationIds.Others]: "Others",
    [LocalizationIds.Documents]: "Documents",
    [LocalizationIds.LinkedOrders]: "Linked Orders",
    [LocalizationIds.Activities]: "Activities",
    [LocalizationIds.People]: "People",
    [LocalizationIds.Team]: "Team",
    [LocalizationIds.TeamMember]: "Team Member",
    [LocalizationIds.From]: "From",
    [LocalizationIds.To]: "To",
    [LocalizationIds.OtherTickets]: "Other Tickets",
    [LocalizationIds.DateFrom]: "Date from",
    [LocalizationIds.DateTo]: "Date to",
    [LocalizationIds.SaveChanges]: "Save Changes",
    [LocalizationIds.NoResults]: "No results has been found",
    [LocalizationIds.ChooseTeamMember]: "Choose team member",
    [LocalizationIds.Assignee]: "Assignee",
    [LocalizationIds.AddUser]: "Add user",
    [LocalizationIds.FileUploaded]: "File uploaded",
    [LocalizationIds.Rev]: "Rev.",
    [LocalizationIds.TotalDays]: "Total days",
    [LocalizationIds.ExpectedDays]: "Expected days",
    [LocalizationIds.TotalWorkedDays]: "Worked days",
    [LocalizationIds.LastUpdate]: "Last Update",
    [LocalizationIds.FileName]: "Filename",
    [LocalizationIds.Download]: "Download",
    [LocalizationIds.Restore]: "Restore",
    [LocalizationIds.CreateRevision]: "Create Revision",
    [LocalizationIds.ShowDeleted]: "Show deleted",
    [LocalizationIds.NoContainerFound]: "No container has been found",
    [LocalizationIds.Description]: "Description",
    [LocalizationIds.AddOrder]: "Add order",
    [LocalizationIds.OrdersFound]: "Orders found",
    [LocalizationIds.WorkOrdersFound]: "Workorders found",
    [LocalizationIds.Close]: "Close",
    [LocalizationIds.SearchOrders]: "Search customer orders",
    [LocalizationIds.SearchWorkOrders]: "Search production orders",
    [LocalizationIds.OrderNumber]: "Order number",
    [LocalizationIds.Typology]: "Typology",
    [LocalizationIds.CommercialCode]: "Commercial Code",
    [LocalizationIds.ArticleModel]: "Article Model",
    [LocalizationIds.Quote]: "Quote",
    [LocalizationIds.Layout]: "Layout",
    [LocalizationIds.NoOrdersFound]: "No Orders Found",
    [LocalizationIds.Article]: "Article",
    [LocalizationIds.Quantity]: "Quantity",
    [LocalizationIds.NoWorkOrdersFound]: "No workorders has been found",
    [LocalizationIds.CreatedBy]: "Created By",
    [LocalizationIds.Origin]: "Origin",
    [LocalizationIds.Activity]: "Activity",
    [LocalizationIds.Yes]: "Yes",
    [LocalizationIds.No]: "No",
    [LocalizationIds.SharedWithCustomer]: "Shared With Customer",
    [LocalizationIds.CannotUploadFiles]: "Cannot upload these files",
    [LocalizationIds.Click]: "Click",
    [LocalizationIds.DragFilesHere]: "Drag files here",
    [LocalizationIds.Or]: "Or",
    [LocalizationIds.ToSearchOne]: "To search one",
    [LocalizationIds.NoMessagesFound]: "There are no messages",
    [LocalizationIds.CreatedBasedOnTicket]: "Created based on ticket",
    [LocalizationIds.LinkedToTicket]: "Linked to ticket",
    [LocalizationIds.On]: "On",
    [LocalizationIds.CreateTicketStartFrom]: "Create new ticket",
    [LocalizationIds.NotSharedWithCustomer]: "Visible only to Simec",
    [LocalizationIds.EditCanGoToCustomer]: "Edit 'Can go to customer'",
    [LocalizationIds.CanGoToCustomer]: "Can go to customer",
    [LocalizationIds.LoginAs]: "Login As",
    [LocalizationIds.Country]: "Country",
    [LocalizationIds.JobSiteFrom]: "Job site from",
    [LocalizationIds.JobSiteTo]: "Job site to",
    [LocalizationIds.JobSite]: "Job site",
    [LocalizationIds.ShowFilter]: "Show filter",
    [LocalizationIds.SubCategories]: "SubCategories",
    [LocalizationIds.SelectCustomerOrMachineToSetReporter]: "Select a Customer or a Machine to select a reporter",
    [LocalizationIds.CustomerCanView]: "Customer can view",
    [LocalizationIds.SimecPrivateTicket]: "Simec private ticket",
    [LocalizationIds.ShowEmptyRows]: "Show technicians without scheduling",
    [LocalizationIds.Technician]: "Technician",
    [LocalizationIds.ClearFilters]: "Clear filters",
    [LocalizationIds.OtherLinkedOrdersInTab]: "Other orders can be found in 'Linked Orders' tab",
    [LocalizationIds.RequiredField]: "{field} is required field",
    [LocalizationIds.SomethingWrong]: "Something is wrong with your user.",
    [LocalizationIds.TryLoginLogout]: "Try to logout and login again: if nothing change ask for technical support.",
    [LocalizationIds.RestoreUser]: "Restore user",
    [LocalizationIds.Groups]: "Groups",
    [LocalizationIds.CustomersSummary]: "Report",
    [LocalizationIds.SummaryActualityPast]: "Done",
    [LocalizationIds.SummaryActualityPresent]: "In progress",
    [LocalizationIds.SummaryActualityFuture]: "Scheduled",
    [LocalizationIds.SortBy]: "Sort by",

    [LocalizationIds.INFO_MoveMessageToTicket]: "Are you sure that you want to move this message on that ticket?",
    [LocalizationIds.INFO_RestoreUserConfirm]: "Are you sure that you want to restore this user?",
    [LocalizationIds.INFO_RemoveTicket]: "Are you sure that you want to remove this ticket?",
    [LocalizationIds.INFO_ChangeCustomersOrders]: "By modifying the customer any orders associated with the ticket will be removed",
    [LocalizationIds.INFO_RemoveUserFromTicketNotifications]: "Are you sure that you want to remove this user from notifications?",
    [LocalizationIds.INFO_TicketRemoved]: "Ticket removed",
    [LocalizationIds.INFO_TicketSaved]: "Ticket saved",
    [LocalizationIds.INFO_DocumentRemove]: "Are you sure that you want to remove this document?",
    [LocalizationIds.INFO_DocumentRestore]: "Are you sure that you want to restore this document?",
    [LocalizationIds.INFO_RemoveUserFromTeam]: "Are you sure that you want to remove this user from team?",
    [LocalizationIds.INFO_FillFields]: "Please fill all fields",
    [LocalizationIds.INFO_TeamSaved]: "Team saved",
    [LocalizationIds.INFO_OrderAlreadySelected]: "Order already selected",
    [LocalizationIds.INFO_DeleteOrder]: "Are you sure that you want to remove this order?",
    [LocalizationIds.INFO_MessageSaved]: "Message saved",
    [LocalizationIds.INFO_ErrorFileUploaded]: "Error on uploading file",
    [LocalizationIds.INFO_AttachmentDuplicated]: "Attachment already added",

    [LocalizationIds.ERR_CANT_MOVE_MESSAGE]: "You can't move this message",
    [LocalizationIds.ERR_FILE_DOWNLOAD]: "An error occurred while downloading the file",
    [LocalizationIds.ERR_FILE_IMPORT]: "An error occurred while importing the file",
    [LocalizationIds.ERR_USER_NOT_FOUND]: "User not found",
    [LocalizationIds.ERR_CANNOT_SET_EMAIL]: "Unable to set Email for the selected user",
    [LocalizationIds.ERR_TICKET_NOT_FOUND]: "Ticket not found",
    [LocalizationIds.ERR_TICKET_NOT_FOUND_CANNOT_SAVE]: "Unable to save: Ticket not found",
    [LocalizationIds.ERR_TICKET_NOT_VISIBLE]: "User not authorized to view this ticket",
    [LocalizationIds.ERR_INVALID_REPORTER_EMAIL]: "Unable to save: invalid email",
    [LocalizationIds.ERR_INVALID_REPORTER_CUSTOMERID]: "Unable to save: invalid customer",
    [LocalizationIds.ERR_DUPLICATE_CODES]: "Unable to save: duplicate codes",
    [LocalizationIds.ERR_CATEGORY_NOT_FOUND]: "Unable to save: category not found",
    [LocalizationIds.ERR_OPERATION_NOT_PERMITTED]: "Operation not permitted",
    [LocalizationIds.ERR_MESSAGE_NOT_FOUND]: "Message not found",
    [LocalizationIds.ERR_DUPLICATED_USER]: "Account with this email already exist in users",
    [LocalizationIds.ERR_DUPLICATED_CUSTOMER]: "Account with this email already exist in customers",
    [LocalizationIds.ERR_MAXDATE_MUST_GREATERTHANOREQUAL_MINDATE]: "Date from must be less than or equal date to",
    [LocalizationIds.ERR_NEW_PASSWORD_REQUIRED]: "E' necessario specificare la nuova password",
    [LocalizationIds.ERR_NEW_PASSWORD_MISMATCH]: "Le due password non corrispondono",
    [LocalizationIds.ERR_RESET_PASSWORD]: "Errore in fase di reset password, si prega di riprovare",
    [LocalizationIds.ERR_UPLOAD_ATTACHMENT]: "Error while uploading attachment",
    [LocalizationIds.ERR_SAVE_MESSAGE]: "Cannot save an empty message",
    [LocalizationIds.ERR_INVALID_CUSTOMER_EMAIL]: "Unable to save: invalid email",
};

export const Localizations: any = {
    "it-IT": itITMessages,
    "en-US": enUSMessages
};